import moment from "moment";

export const CHAIN_OF_CUSTODY_LOCAL_STORAGE_KEY = "coc_headers";
export const EARLIEST_COC_ISSUED_AT = moment("2018-01-01");
